import state from './state';

export default {
  objektart: () => state.allgemeineAngaben.objektart,
  ermittlungsstichtag: () => state.allgemeineAngaben.ermittlungsstichtag,
  baujahr: () => state.allgemeineAngaben.baujahr,
  wohnungsnummer: () => state.allgemeineAngaben.wohnungsnummer,
  anzahlWohneinheiten: () => state.allgemeineAngaben.anzahlWohneinheiten,
  anzahlNutzeinheiten: () => state.allgemeineAngaben.anzahlNutzeinheiten,
  wohnflaeche: () => state.allgemeineAngaben.wohnflaeche,
  nutzflaeche: () => state.allgemeineAngaben.nutzflaeche,
  isValid: () => state.allgemeineAngaben.valid(),

  kaufpreis: () => state.auftragsdaten.kaufpreis,
  grundstuecksflaeche: () => state.auftragsdaten.grundstuecksflaeche,
  grunderwerbssteuern: () => state.auftragsdaten.grunderwerbssteuern,
  notarkostenKaufvertrag: () => state.auftragsdaten.notarkostenKaufvertrag,
  kostenGrundbucheintragung: () => state.auftragsdaten.kostenGrundbucheintragung,
  bodenrichtwertKaufzeitpunkt: () => state.auftragsdaten.bodenrichtwertKaufzeitpunkt,
  vermietetKaufzeitpunkt: () => state.auftragsdaten.vermietetKaufzeitpunkt,
  kaltmieteKaufzeitpunkt: () => state.auftragsdaten.kaltmieteKaufzeitpunkt,
  isAuftragsdatenValid: () => state.auftragsdaten.valid(),

  baulasten: () => state.lasten.baulasten,
  erlaeuterungBaulasten: () => state.lasten.erlaeuterungBaulasten,
  altlasten: () => state.lasten.altlasten,
  erlaeuterungAltlasten: () => state.lasten.erlaeuterungAltlasten,
  isLastenValid: () => state.lasten.valid(),

  kernsanierung: () => state.modernisierungen.kernsanierung,
  jahrDerKernsanierung: () => state.modernisierungen.jahrDerKernsanierung,
  bodenbelaegeModernisierung: () => state.modernisierungen.bodenbelaege.modernisierung,
  bodenbelaegeModernisierungJahr: () => state.modernisierungen.bodenbelaege.jahrDerModernisierung,
  baederModernisierung: () => state.modernisierungen.baeder.modernisierung,
  baederModernisierungJahr: () => state.modernisierungen.baeder.jahrDerModernisierung,
  heizungModernisierung: () => state.modernisierungen.heizung.modernisierung,
  heizungModernisierungJahr: () => state.modernisierungen.heizung.jahrDerModernisierung,
  leitungenModernisierung: () => state.modernisierungen.leitungen.modernisierung,
  leitungenModernisierungJahr: () => state.modernisierungen.leitungen.jahrDerModernisierung,
  fensterModernisierung: () => state.modernisierungen.fenster.modernisierung,
  fensterModernisierungJahr: () => state.modernisierungen.fenster.jahrDerModernisierung,
  daemmungModernisierung: () => state.modernisierungen.daemmung.modernisierung,
  daemmungModernisierungJahr: () => state.modernisierungen.daemmung.jahrDerModernisierung,
  dachModernisierung: () => state.modernisierungen.dach.modernisierung,
  dachModernisierungJahr: () => state.modernisierungen.dach.jahrDerModernisierung,
  raumaufteilungModernisierung: () => state.modernisierungen.raumaufteilung.modernisierung,
  raumaufteilungModernisierungJahr: () => state.modernisierungen.raumaufteilung.jahrDerModernisierung,
  isModernisierungValid: () => state.modernisierungen.valid(),

  grundbuchauszug: () => state.auftragsunterlagen.grundbuchauszug,
  kaufvertrag: () => state.auftragsunterlagen.kaufvertrag,
  grundriss: () => state.auftragsunterlagen.grundriss,
  mietvertraege: () => state.auftragsunterlagen.mietvertraege,
  energieausweis: () => state.auftragsunterlagen.energieausweis,
  bauunterlagen: () => state.auftragsunterlagen.bauunterlagen,
  teilungserklaerung: () => state.auftragsunterlagen.teilungserklaerung,
  zusatzdokument: () => state.auftragsunterlagen.zusatzdokument,
  isAuftragsunterlagenValid: () => state.auftragsunterlagen.valid(),

  ansprechpartnerNachname: () => state.ansprechpartner.nachname,
  ansprechpartnerVorname: () => state.ansprechpartner.vorname,
  ansprechpartnerTelefon: () => state.ansprechpartner.telefon,
  ansprechpartnerErlaeuterung: () => state.ansprechpartner.erlaeuterung,
  alternateAnsprechpartnerName: () => state.ansprechpartner.altName,
  alternateAnsprechpartnerFunction: () => state.ansprechpartner.altFunktion,
  alternateAnsprechpartnerTelefon: () => state.ansprechpartner.altTelefon,
  alternateAnsprechpartnerEmail: () => state.ansprechpartner.altEmail,
  isAnsprechpartnerValid: () => state.ansprechpartner.valid(),

  defaultRechnungName1: () => state.defaultRechnung.name1,
  defaultRechnungName2: () => state.defaultRechnung.name2,
  defaultRechnungPlz: () => state.defaultRechnung.plz,
  defaultRechnungOrt: () => state.defaultRechnung.ort,
  defaultRechnungStr: () => state.defaultRechnung.str,
  defaultRechnungHnr: () => state.defaultRechnung.hnr,
  isDefaultRechnungValid: () => state.defaultRechnung.valid(),

  alternativeRechnungName1: () => state.alternativeRechnung.name1,
  alternativeRechnungName2: () => state.alternativeRechnung.name2,
  alternativeRechnungPlz: () => state.alternativeRechnung.plz,
  alternativeRechnungOrt: () => state.alternativeRechnung.ort,
  alternativeRechnungStr: () => state.alternativeRechnung.str,
  alternativeRechnungHnr: () => state.alternativeRechnung.hnr,
  useDefaultRechnung: () => state.alternativeRechnung.useDefault,
  isAlternativeRechnungValid: () => state.alternativeRechnung.valid(),

  isStillUploading() {
    function streamToBoolean(path) {
      return Object.values(path)
        .flatMap(a => a)
        .map(file => file?.isStillUploading())
        .reduce((a, b) => a || b);
    }

    return streamToBoolean({
      a: state.auftragsunterlagen.grundbuchauszug,
      b: state.auftragsunterlagen.kaufvertrag,
      c: state.auftragsunterlagen.grundriss,
      d: state.auftragsunterlagen.mietvertraege,
      e: state.auftragsunterlagen.energieausweis,
      f: state.auftragsunterlagen.bauunterlagen,
      g: state.auftragsunterlagen.teilungserklaerung,
      h: state.auftragsunterlagen.mietvertraege,
      i: state.auftragsunterlagen.zusatzdokument
    });
  },

  exportData(state) {
    let unwrap = ({modernisierung, jahrDerModernisierung}) => ({
      modernisierung,
      jahrDerModernisierung
    });
    return {
      allgemeineAngaben: (({
                             auftraggeberName1,
                             auftraggeberName2,
                             objektart,
                             baujahr,
                             wohnungsnummer,
                             anzahlWohneinheiten,
                             anzahlNutzeinheiten,
                             wohnflaeche,
                             nutzflaeche,
                             ermittlungsstichtag
                           }) => ({
        auftraggeberName1,
        auftraggeberName2,
        ermittlungsstichtag,
        baujahr,
        wohnungsnummer,
        anzahlWohneinheiten,
        anzahlNutzeinheiten,
        wohnflaeche,
        nutzflaeche,
        objektart,
      }))(state.allgemeineAngaben),
      auftragsdaten: (({
                         kaufpreis,
                         grundstuecksflaeche,
                         grunderwerbssteuern,
                         notarkostenKaufvertrag,
                         kostenGrundbucheintragung,
                         bodenrichtwertKaufzeitpunkt,
                         vermietetKaufzeitpunkt,
                         kaltmieteKaufzeitpunkt
                       }) => ({
        kaufpreis,
        grundstuecksflaeche,
        grunderwerbssteuern,
        notarkostenKaufvertrag,
        kostenGrundbucheintragung,
        bodenrichtwertKaufzeitpunkt,
        vermietetKaufzeitpunkt,
        kaltmieteKaufzeitpunkt
      }))(state.auftragsdaten),
      lasten: (({
                  baulasten,
                  erlaeuterungBaulasten,
                  altlasten,
                  erlaeuterungAltlasten
                }) => ({
        baulasten,
        erlaeuterungBaulasten,
        altlasten,
        erlaeuterungAltlasten
      }))(state.lasten),
      modernisierungen: (({
                            kernsanierung,
                            jahrDerKernsanierung,
                            bodenbelaege,
                            baeder,
                            heizung,
                            leitungen,
                            fenster,
                            daemmung,
                            dach,
                            raumaufteilung
                          }) => ({
        kernsanierung,
        jahrDerKernsanierung,
        bodenbelaege: unwrap(bodenbelaege),
        baeder: unwrap(baeder),
        heizung: unwrap(heizung),
        leitungen: unwrap(leitungen),
        fenster: unwrap(fenster),
        daemmung: unwrap(daemmung),
        dach: unwrap(dach),
        raumaufteilung: unwrap(raumaufteilung),
      }))(state.modernisierungen),
      kontaktdaten: (({
                           telefon,
                           erlaeuterung,
                           altName,
                           altFunktion,
                           altTelefon,
                           altEmail
                         }) => ({
        telefon,
        erlaeuterung,
        altName,
        altFunktion,
        altTelefon,
        altEmail
      }))(state.ansprechpartner),
      alternativeRechnung: (({
                          name1,
                          name2,
                          plz,
                          ort,
                          str,
                          hnr,
                          useDefault
                        }) => ({
        name1,
        name2,
        plz,
        ort,
        str,
        hnr,
        useDefault
      }))(state.alternativeRechnung),
    };
  },
  ausSpeicherGeladen: () => state.ausSpeicherGeladen,
};
